import axios from "axios";

export const state = {
    products: [],
};

export const getters = {
    products: state => state.products,
};

export const mutations = {
    setProducts(state, newValue) {
        state.products = newValue
    },
};

export const actions = {
    fetchProducts({ commit }) {
        axios.get('/products').then(res => {
            commit('setProducts', res.data.products)
        })
    },
    filterProducts({ commit }, {search}) {
        let formData = new FormData();
        formData.append("name", search);
        axios.post('/filterproducts',formData).then(res => {
            commit('setProducts', res.data.products)
        })
    },
    filterPrice({ commit }, {search}) {
        let formData = new FormData();
        formData.append("price", search);
        axios.post('/filterproductsprice',formData).then(res => {
            commit('setProducts', res.data.products)
        })
    },
    filterProductsByCategory({commit}, {category}){
        let formData = new FormData();
        formData.append("category", category);
        axios.post('/filterproductscategory',formData).then(res => {
            commit('setProducts', res.data.products)
        })
    },
    findProducts({commit}, {product}){
        let formData = new FormData();
        formData.append("product", product);
        axios.post('/findproduct',formData).then(res => {
            commit('setProducts', res.data.products)
        })
    }
};
